import { createSlice } from "@reduxjs/toolkit";
import en from "./lang/en.json";
// import th from "./lang/th.json";

const initialState = {
  language: localStorage.getItem("language") || "en", // โหลดค่าจาก localStorage,
  msg: en,
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.language = action.payload;
      localStorage.setItem("language", action.payload); // บันทึกค่าไว้
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice;
